import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4393f1ac&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=4393f1ac&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4393f1ac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\tx_projects\\plat-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4393f1ac')) {
      api.createRecord('4393f1ac', component.options)
    } else {
      api.reload('4393f1ac', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4393f1ac&scoped=true", function () {
      api.rerender('4393f1ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/platformCoupon/couponList/index.vue"
export default component.exports